<script setup>
import {computed, provide, ref} from "vue";
import TopBar from "@/views/trackers/trackers/TopBar.vue";
import FoldersList from "@/views/trackers/trackers/folders/FoldersList.vue";
import useTrigger from "@/composables/useTrigger";
import TrackersList from "@/views/trackers/trackers/trackers/TrackersList.vue";
import Helper from "@/components/Helper.vue";
import {useStore} from "vue2-helpers/vuex";

const store = useStore();
const [updateSearch, setNeedUpdateSearch] = useTrigger();

const filterByCreator = ref(null);
const search = ref("");

const userCanAddTracker = computed(() => store.state.user.permissions.includes('tracker-create'));

provide('filterByCreator', filterByCreator);
provide('search', search);
provide('updateSearch', updateSearch);

provide('setNeedUpdateSearch', setNeedUpdateSearch);
</script>

<template>
    <div>
        <TopBar/>

        <div class="main-inner main-inner--scroll">
            <FoldersList/>

            <TrackersList
                :user-can-add-tracker="userCanAddTracker"
            />
        </div>

        <helper
            v-if="store.getters.isEnterprise"
            page="trackers"
        />
    </div>
</template>

<style scoped>

</style>
